// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".time {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  font-size: 11px !important;\n  opacity: 0.7;\n  margin-top: auto;\n  margin-left: 5px;\n}\n.time > .fa,\n.time .far {\n  margin-left: 4px;\n}\n.time > .fa-check {\n  color: #008e9e;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
